import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My first weekly photowalk",
  "description": "",
  "published": "2008-11-24T00:00:00.000Z",
  "redirect_from": ["/blog/my-first-weekly-photowalk/swizec/37"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I went on my first photowalk, an activity I promised myself I'd henceforth partake in at least once a week. First time I came into contact with photowalking was in some retweets by people on twitter that were talking about `}<a parentName="p" {...{
        "href": "http://www.photowalklist.com/"
      }}>{`photowalklist.com`}</a>{` and after observing for a while it touched something within me - the photographer I used to be quite some years ago (got my first proper camera at about 4 and then continued dabbling until about 15).`}</p>
    <p>{`Taking night-time photography of Ljubljana covered in the first snow of 2008 was bloody wonderful, sure I found out I need a tripod, yes I'm displeased with most of hte photos because they're too bright and of course my fingers damn well nearly fell off. But that's what photowalking is about, finding out how much you suck so you can improve.`}</p>
    <p>{`I will be making a photowalk post every week from now on and will include a lovely widget from `}<a parentName="p" {...{
        "href": "http://www.fotonauts.com/"
      }}>{`Fotonauts`}</a>{` - a photography sharing website/app that I'm helping beta test.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      